/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     ItemTypes
//   Details:    Item types constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 102715 16/08/19 JC  M01  Added allContacts
// 103782 10/12/19 JC  M02  Expanded for training
//-------------------------------------------------------
*/
export const itemTypes = {
	notice: 'NOTICE',
	document: 'DOCUMENT',
	payRecord: 'PAY_RECORD',
    request: 'REQUEST',
    contact: 'CONTACT', //M01
    training: 'TRAINING' //M02
};
